module.exports = __webpack_public_path__ + "img/2.88830434.png";